import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./payment-conditions_style.css";
import { FaUndo } from "react-icons/fa";
  
function DeletedPaymentConditions ({ setUpdateTrigger, updateTrigger }) {

    const [deletedPaymentConditions, setDeletedPaymentConditions] = useState([]);

    const getDeletedPaymentConditions = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_conditions/getAllDeleted`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                setDeletedPaymentConditions(res.data.data);
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
        }
    };

    const restorePaymentCondition = async (id) => {
        try {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¿Quieres restaurar esta condición de pago?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: "Sí, restaurar",
                denyButtonText: "No, cancelar",
                reverseButtons: true,
                buttonsStyling: true,
            });

            if (result.isConfirmed) {
                const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_conditions/restore/${id}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });

                Swal.fire("¡Restaurado!", "La condición de pago ha sido restaurada.", "success");
                setUpdateTrigger(!updateTrigger);
                getDeletedPaymentConditions();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    useEffect(() => {
        getDeletedPaymentConditions();
    }, [updateTrigger]);

    return (
        <div className='table-responsive'>
            <h3 className="mb-4">Condiciones de Pago Eliminadas</h3>
            <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Código</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {deletedPaymentConditions.map((paycond) => (
                        <tr key={paycond.id} data-master-id={paycond.id}>
                            <td>{paycond.name}</td>
                            <td>{paycond.code}</td>
                            <td>
                                <FaUndo className='restoreButton' onClick={() => { restorePaymentCondition(paycond.id) }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

}

export default DeletedPaymentConditions;